import agent from './agent'

export function reportBug(message: string, stackTrace: string) {
  return agent.post('/logs', { message, stackTrace })
}
